"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
const styleOverrides = {
  paper: {
    '&.OriSelectPaper': {
      border: `1px solid ${_constants.colors.oriGrey[500]}`,
      borderRadius: 5,
      marginTop: '5px'
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
